import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { SEARCH_STRING_EXPERIMENT, SEARCH_STRING_EXPERIMENT_GROUP } from 'shared/constants/experiments';
import { EXPERIMENTS_CONFIG_KEY, getExperimentGroup, TExperimentGroups } from 'shared/utils/experiments';

/**
 * Попал ли пользователь в группу эксперимента с поисковой строкой.
 *
 * Читает группу из конфига напрямую и экспозицию не отправляет — её шлёт хост.
 */
export function useSearchStringExperiment(): boolean {
  const { config } = useApplicationContext();

  const groups = config.get<TExperimentGroups>(EXPERIMENTS_CONFIG_KEY);

  return getExperimentGroup(groups, SEARCH_STRING_EXPERIMENT) === SEARCH_STRING_EXPERIMENT_GROUP;
}
